<template>
    <div class="session__show_tabs">
        <div class="session__show_tabs_top">
            <div class="columns is-block-mobile is-vcentered">
                <div class="column">
                    <div class="session__show_tabs_top_nav">
                        <ul>
                            <li
                                v-for="(tab, index) in filteredTabs"
                                :key="index"
                            >
                                <button
                                    @click="switchTab(tab.name)"
                                    :class="['session__show_tabs_nav_button', 'btn', 'btn--nav', tab.name === activeTab ? 'btn--primary' : '']"
                                    id="session-show-tabs-top-nav-switch"
                                >{{ toCapitalize(fromKebabCaseToString(tab.name)) }}
                                </button>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="column is-narrow">
                    <div class="session__show_tabs_top_other">
                        <div class="columns is-block-mobile columns--margin-2-mobile custom--line is-vcentered">
                            <div class="column"></div>
                            <template v-if="!sessionSessionInfoHasEnded">
                                <div class="column is-narrow">
                                    <div class="session__show_tabs_top_other_accepting">{{ sessionAcceptingLabel }} {{
                                        sessionAcceptingDate }}
                                    </div>
                                </div>
                            </template>
                            <div class="column is-narrow">
                                <div
                                    class="session__show_tabs_top_other_item session__show_tabs_top_other_item--spaces">
                                    <v-icon name="users"/>
                                    <span>{{ sessionSpaces }}</span>
                                </div>
                            </div>
                            <template v-if="!sessionUserIsSubscribed">
                                <div class="column is-narrow">
                                    <div
                                        class="session__show_tabs_top_other_item session__show_tabs_top_other_item--bookingstatus custom--padding">
                                        <component-status :status="sessionUserBookingStatus"/>
                                    </div>
                                </div>
                            </template>
                            <template v-if="sessionUserIsSubscribed">
                                <div class="column is-narrow">
                                    <div
                                        class="session__show_tabs_top_other_item session__show_tabs_top_other_item--usersubscribestatus">
                                        <component-status :status="sessionUserIsSubscribed ? 'On waitlist' : ''"/>
                                    </div>
                                </div>
                            </template>
                            <template v-if="sessionUserCompletionStatus && false">
                                <div class="column is-narrow">
                                    <div
                                        class="session__show_tabs_top_other_item session__show_tabs_top_other_item--completionstatus">
                                        <component-status :status="sessionUserCompletionStatus"/>
                                    </div>
                                </div>
                            </template>
                            <div
                                v-show="allowSelfCancelBooking || allowSelfCreateBooking"
                                class="column is-narrow"
                            >
                                <div class="session__show_tabs_top_other_item session__show_tabs_top_other_item--actions">
                                    <session-show-booking/>
                                </div>
                            </div>
                            <template v-if="(!sessionHasSpacesAvailable && !sessionHasUserBookingStatusBooked) || sessionUserIsSubscribed">
                                <div class="column is-narow">
                                    <div
                                        class="session__show_tabs_top_other_item session__show_tabs_top_other_item--actions">
                                        <session-show-waitlist/>
                                    </div>
                                </div>
                            </template>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="session__show_tabs_content">
                <div
                    :key="tabs[0].name"
                    v-if="tabs[0].name === activeTab && tabs[0].visible()"
                    class="session__show_tabs_content_inner"
                >
                    <session-show-dates/>
                    <session-show-sessions/>
                </div>
                <div
                    :key="tabs[1].name"
                    v-if="tabs[1].name === activeTab && tabs[1].visible()"
                    class="session__show_tabs_content_inner"
                >
                    <session-show-people/>
                </div>
                <div
                    :key="tabs[2].name"
                    v-if="tabs[2].name === activeTab && tabs[2].visible()"
                    class="session__show_tabs_content_inner"
                >
                    <session-show-attendance/>
                </div>
                <div
                    :key="tabs[3].name"
                    v-if="tabs[3].name === activeTab && tabs[3].visible()"
                    class="session__show_tabs_content_inner"
                >
                    <session-show-feedback/>
                </div>
        </div>
    </div>
</template>

<script>
import SessionShowDates from '@/components/ebs/sessions/show/SessionShowDates'
import SessionShowSessions from '@/components/ebs/sessions/show/SessionShowSessions'
import SessionShowPeople from '@/components/ebs/sessions/show/SessionShowPeople'
import SessionShowAttendance from '@/components/ebs/sessions/show/SessionShowAttendance'
import { User } from '@/User'
import SessionShowFeedback from './SessionShowFeedback'
import ComponentStatus from '@/components/default/shared/ComponentStatus'
import SessionShowBooking from '@/components/ebs/sessions/show/SessionShowBooking'
import SessionShowWaitlist from '@/components/ebs/sessions/show/SessionShowWaitlist'

export default {
  components: {
    SessionShowFeedback,
    SessionShowWaitlist,
    SessionShowSessions,
    SessionShowBooking,
    ComponentStatus,
    SessionShowAttendance,
    SessionShowPeople,
    SessionShowDates
  },
  name: 'session-show-tabs',
  data () {
    return {
      user: new User(this.$store.getters.getAuthUserSecondStageTokenData),
      tabs: [
        { name: 'date-and-time', visible: () => true },
        {
          name: 'bookings',
          visible: () => {
            return this.user.isEventCoordinator() || this.user.isSessionTrainer(this.sessionTrainers)
          }
        },
        {
          name: 'attendance-and-assessment',
          visible: () => {
            return (
              this.user.isEventCoordinator() ||
            this.user.isSessionTrainer(this.sessionTrainers)
            ) && (
              this.sessionCompletionEnableRegisters ||
            this.sessionCompletionType === 'assessment'
            )
          }
        },
        {
          name: 'trainers-feedback',
          visible: () => {
            return (
              this.user.isEventCoordinator() ||
            this.user.isSessionTrainer(this.sessionTrainers)
            ) && (
              this.sessionCompletionFormRequired
            )
          }
        }
      ],
      activeTab: 'date-and-time'
    }
  },
  computed: {
    filteredTabs: function () {
      return this.tabs.filter(tab => {
        return tab.visible()
      })
    },
    eventStatus: function () {
      return this.$store.getters.getEventStatus
    },
    sessionStatus: function () {
      return this.$store.getters.getSessionStatus
    },
    sessionBookingInfoAcceptationAllowed: function () {
      return this.$store.getters['getSessionBookingInfoAcceptationAllowed']
    },
    sessionBookingInfoCancellationAllowed: function () {
      return this.$store.getters['getSessionBookingInfoCancellationAllowed']
    },
    sessionCancellationSelfAllowed: function () {
      return this.$store.getters['getSessionCancellationSelfAllowed']
    },
    sessionHasSpacesAvailable: function () {
      return this.$store.getters['getSessionHasSpacesAvailable']
    },
    sessionUserIsSubscribed: function () {
      return this.$store.getters['getSessionUserIsSubscribed']
    },
    sessionHasUserBookingStatusBooked: function () {
      return this.$store.getters['getSessionHasUserBookingStatusBooked']
    },
    sessionCompletionFormRequired: function () {
      return this.$store.getters['getSessionCompletionTrainerFeedbackRequired']
    },
    //
    sessionAcceptingLabel: function () {
      if (this.sessionUserBookingStatus === 'booked') {
        return this.$t('ebs.sessions.show.description.acceptingCancellationsUntil')
      } else {
        return this.$t('ebs.sessions.show.description.acceptingBookingsUntil')
      }
    },
    sessionAcceptingDate: function () {
      const cancellationDate = this.sessionBookingInfoCancellationDate
      const acceptationDate = this.sessionBookingInfoAcceptationDate
      const bookingStatus = this.sessionUserBookingStatus
      let date
      if (bookingStatus === 'booked') {
        date = cancellationDate ? this.fromUTCDateTimeToLocalISOCustom(cancellationDate) : undefined
      } else {
        date = acceptationDate ? this.fromUTCDateTimeToLocalISOCustom(acceptationDate) : undefined
      }
      return this.toLocaleDateTime(date)
    },
    sessionBookingInfoAcceptationDate: function () {
      return this.$store.getters['getSessionBookingInfoAcceptationDate']
    },
    sessionBookingInfoCancellationDate: function () {
      return this.$store.getters['getSessionBookingInfoCancellationDate']
    },
    sessionSpaces: function () {
      return this.$store.getters.getSessionSpaces
    },
    sessionTrainers: function () {
      return this.$store.getters.getSessionTrainers
    },
    sessionUserBookingStatus: function () {
      return this.$store.getters.getSessionUserBookingStatus
    },
    sessionUserCompletionStatus: function () {
      return this.$store.getters.getSessionUserCompletionStatus
    },
    sessionCompletionEnableRegisters: function () {
      return this.$store.getters['getSessionCompletionEnableRegisters']
    },
    sessionCompletionType: function () {
      return this.$store.getters['getSessionCompletionType']
    },
    sessionSessionInfoHasEnded: function () {
      return this.$store.getters['getSessionSessionInfoHasEnded']
    },
    bookingValidate: function () {
      return this.$store.getters['getBookingValidate']
    },
    allowSelfCancelBooking: function () {
      return this.$store.getters.getSessionAllowSelfCancelBooking
    },
    allowSelfCreateBooking: function () {
      return this.$store.getters.getSessionAllowSelfCreateBooking
    }
  },
  mounted () {
    const routeHash = this.$route.hash.split('?')[0].replace('#', '')
    if (routeHash) {
      this.switchTab(routeHash)
    }
  },
  methods: {
    switchTab: function (tab) {
      this.$router.push({ hash: `#${tab}` })
      this.activeTab = tab
    }
  }
}
</script>

<style lang="scss">
    @import "~@/assets/scss/components/ebs/sessions/sessionshowtabs";
</style>
